import { BaseApi } from 'src/api/BaseApi';
import { DEMO_USERS } from 'src/api/demo/users';

class UserApi extends BaseApi {
  async getAllUsers() {
    // Return demo users when in demo mode
    // Regular users will still get real data from the backend
    if (this.isDemo()) {
      return DEMO_USERS;
    }

    const response = await this.postRequest('user/all');
    return response.data;
  }

  async getCurrentUserInfo() {
    // Demo mode check handled by the auth flow
    const response = await this.postRequest('auth/getuserinfo');
    return response.data;
  }
}

export const userApi = new UserApi();
